import { AgTechQuery, useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { SaleInvoiceModifier } from "./SaleInvoiceModifierData";
import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";

export const SaleInvoiceModifierQueryKey = 'SaleInvoiceModifiers';

export const InvoiceModifierDataGetAllInvoiceModifiersQuery: AgTechQuery<any, AgTechIndex<SaleInvoiceModifier>> = {
    queryKey: () => [SaleInvoiceModifierQueryKey],
    query: async (props) => {
        return await props.http.getEntity<SaleInvoiceModifier[], AgTechIndex<SaleInvoiceModifier>>({
            request: 'InvoiceModifiers',
            convert: InvoiceModifiers => Index(InvoiceModifiers, InvoiceModifier => InvoiceModifier.id)
        });
    },
    content: {
        loadingText: 'Loading charges and discounts...',
        failureText: 'Failed to load charges and discounts.'
    }
}

/// Providers

export const SaleInvoiceModifierDataProvider = (props: {
    children: (InvoiceModifiers: AgTechIndex<SaleInvoiceModifier>) => JSX.Element
}) => {
    const getInvoiceModifiersQuery = useAgTechQuery({
        query: InvoiceModifierDataGetAllInvoiceModifiersQuery
    });

    return (
        <AgTechQueryLoadingSurface
            query={getInvoiceModifiersQuery}
            children={props.children}
        />
    )
}